<template>
    <div class="forecastNameWrapper" :style="{ backgroundColor: statusColor }">
        <div class="name">
            <div class="title">{{ forecast.reference }} • {{ forecast.name }}</div>
        </div>
        <div class="status-container">
            <div class="state" v-if="forecast.isTransmissionApproved === true">
                <p><i class="fas fa-check"></i> <span>Approved</span></p>
            </div>
            <div class="status">{{ statusName }}</div>
        </div>
    </div>
</template>
<script>
import { getStatusColor, getStatusName } from "@/components/forecasts/utils/utilis";

export default {
    props: {
        forecast: {
            type: Object,
            required: true
        },
        height: {
            type: Number,
            default: 30
        }
    },
    computed: {
        statusName() {
            return this.forecast ? getStatusName(this.forecast.deleted ? "DELETE" : this.forecast.status) : "";
        },
        statusColor() {
            return this.forecast ? getStatusColor(this.forecast.deleted ? "DELETE" : this.forecast.status) : "";
        }
    }
};
</script>
<style lang="scss" scoped>
.forecastNameWrapper {
    color: #ffffff;
    display: flex;
    text-transform: uppercase;
    position: relative;
    padding: 0;
    @media (max-width: 767px) {
        flex-direction: column;
    }
}
.name {
    text-align: left;
    font-weight: bold;
    padding: 7.5px 0 7.5px 20px;
    max-width: 75%;
    @media (max-width: 767px) {
        text-align: center;
        width: 100%;
        max-width: 100%;
    }
}
.status-container {
    position: absolute;
    top: 0;
    right: 15px;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    @media (max-width: 767px) {
        position: relative;
        width: 100%;
        justify-content: center;
        right: 0;
    }
    .state {
        margin-right: 50px;
        background-color: #776f7e;
        position: relative;
        height: 100%;
        z-index: 0;
        padding: 0 40px;
        display: flex;
        align-items: center;
        text-align: center;
        overflow: hidden;
        p {
            margin: 0;
            svg {
                margin-right: 5px;
            }
        }

        &:before {
            content: "";
            position: absolute;
            display: block;
            top: 50%;
            left: 0;
            transform: translateY(-50%) translateX(-50%) rotate(17deg);
            height: 150%;
            width: 20px;
            background-color: #4f4754;
            z-index: 1;
        }

        &:after {
            content: "";
            position: absolute;
            display: block;
            top: 50%;
            right: 0;
            transform: translateY(-50%) translateX(50%) rotate(17deg);
            height: 150%;
            width: 20px;
            background-color: #4f4754;
            z-index: 1;
        }
        @media (max-width: 1024px) and (min-width: 768px) {
            padding: 0 20px;
            margin-right: 0;
            svg {
                margin: 0;
            }
            span {
                display: none;
            }
        }

        @media (max-width: 767px) {
            margin-right: 10px;
            padding: 7px 40px;
        }
    }
    .status {
        text-align: right;
        padding: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// ForecastNameBanner.vue?13fd76fd